import React,{useState, useEffect, Fragment} from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { api, WorkshopListURL } from "../../../apis/urls";
import RichTextEditor from "@mantine/rte";
import { ButtonGroup, DatePicker as DatePickers, Dropdown, Input, Button, Panel, Steps, Checkbox, InputGroup, Progress, Col, InputNumber, InputPicker, Message } from "rsuite";
import moment from "moment";
import { Radio } from "@nextui-org/react";
import RteEventComponent from "./TextEditor";
import { DatePicker, message, Space, Spin } from "antd";
import 'antd/dist/antd.css';
import FullPageLoader from "../../../common-components/loader";
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";

const { MonthPicker, RangePicker } = DatePicker;




const WorkshopUpdate = ({parentCallback}) => {

    const[ result,setResult ] = useState('');

    const [title,setTitle] = useState('');
    const [description,setDescription] = useState('');
    const [startDate,setStartDate] = useState('');
    const [startTime,setStartTime] = useState('');
    const [endDate,setEndDate] = useState('');
    const [endTime,setEndTime] = useState('');
    const [location, setLocation] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [states,setStates] = useState('');
    const [zip, setZip] = useState('');
    const [pageURL, setPageURL] = useState('');
    const [image,setImage] = useState('');
    const [fileSelect, setFileSelect] = useState('');
    const [mschool, setMSchool] = useState('NO');
    const [pPrice,setPPrice] = useState('');
    const [nmPrice, setNMprice] = useState('');
    const [rdead, setRdead] = useState('');
    const [lrPrice, setLRprice]=useState('');
    const [mnAtte, setMNatte]=useState(0);
    const [prePrice, setPrePrice]=useState('')
    const [regSchool, setRegSchool] = useState('');
    const [conSchool, setConSchool] = useState('');
    const [regFir, setRegFir]=useState('');
    const [regLas, setRegLas]=useState('');
    const [regTit, setRegTit]=useState('');
    const [regEmail, setRegEmail]=useState('');
    const [regSpe, setRegSpe]=useState('');
    const [regPhone, setRegPhone]=useState('');
    const [startDateErr,setStartDateErr] = useState(false);
    const [endDateErr,setEndDateErr] = useState(false);


    const statess = ["AL","AK","AS","AR","AZ","CA","CO","CT","DE","DC","FM","FL","GA","GU","HI","ID","IL","IN","IA","KS","KY","LA","ME","MH","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PW","PA","PR","RI","SC","SD","TN","TX","UT","VT","VI","VA","WA","WV","WI","WY"];
    const datavalidation = [{value: 'NOT_SHOW', label:"Do not show"},{value: 'REQUIRED', label:"Required"}, {value:'OPTIONAL',label:"Optional"}].map(item => ({ label: item.label, value: item.value }));
    const datavalidations = [{value: 'REQUIRED', label:"Required"}, {value:'OPTIONAL',label:"Optional"}].map(item => ({ label: item.label, value: item.value }));

    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        EventViews();
        // console.log("data =>>>>>", value)
      },[])






      const [step, setStep] = useState(0);
      const onChange = nextStep => {
        setStep(nextStep < 0 ? 0 : nextStep > 3 ? 3 : nextStep);
      };
    
      const onNext = () => onChange(step + 1);
      const onPrevious = () => onChange(step - 1);


    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/workshop")
        
    }


    const { id } = useParams();


    const EventViews = ()=>{
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const instance = axios.create({
            baseURL: WorkshopListURL+'/'+id,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            console.log(res.data.data.validation)
            setResult(res.data.data);
            let value = res.data.data
            parentCallback(decode(value.title))
            setTitle(decode(value.title))
            setDescription(value.description)
            setStartDate(value.start_date);
            setEndDate(value.end_date);
            setStartTime(moment(value.start_time).format('HH:mm'));
            setEndTime(moment(value.end_time).format('HH:mm'));
            setLocation(value.location)
            setStates(value.state)
            setAddress(value.address)
            setCity(value.city)
            setZip(value.zipcode)
            setImage(value.image)
            setPageURL(value.link_url)
            setMSchool(value.member_schools)
            setPPrice(value.participant_price)
            setNMprice(value.non_member_price)
            setRdead(moment(value.registration_deadline).format('YYYY-MM-DD'))
            setLRprice(value.late_registration_price)
            setMNatte(value.max_number_attendees)
            setPrePrice(value.presenter_price)
            setRegSchool(value.validation.registrants_school_organization)
            setConSchool(value.validation.contact_school_organization)
            setRegFir(value.validation.registrants_firstname)
            setRegLas(value.validation.registrants_lastname)
            setRegTit(value.validation.registrants_title_school)
            setRegEmail(value.validation.registrants_email)
            setRegSpe(value.validation.registrants_special_dietery)
            setRegPhone(value.validation.registrants_phone)

            if(value.image){
                setFileSelect((value.image).split("/")[3])
            }
          });

    }


    const EventSubmit = () => {

        // setLoading(true)

            let token = "Bearer "+localStorage.getItem('token');
            const data = {
                title:title,
                description:description,
                start_date:startDate,
                end_date:endDate,
                location:location,
                address:address,
                city:city,
                state:states,
                zipcode:zip, 
                link_url:pageURL,
                image:image,
                member_schools: mschool,
                participant_price: pPrice,
                non_member_price: nmPrice === ''?null:nmPrice,
                registration_deadline: rdead,
                late_registration_price: lrPrice,
                max_number_attendees: mnAtte,
                presenter_price: prePrice,
                reg_school_org: "NOTSHOW",
                contact_school_org: "NOTSHOW",
                reg_firstname: "REQUIRED",
                reg_lastname: "REQUIRED",
                reg_title_school: regTit,
                reg_email: "REQUIRED",
                reg_special_dietery: "NOTSHOW",
                reg_phone: "REQUIRED"
            }
            
            console.log("regphone", data)
            // console.log("datas ====>>>>>>>",  data)
            
            const instance = axios.create({

                baseURL: WorkshopListURL+'/'+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
                        
            instance.put('',data).then((response) =>{
    
                // console.log("response ====>>>>>>> success")

                message.success(title+' conference manager updated successfully')

                navigate("/workshop")

            }).catch((error) =>{

                console.log("123456", error)
            });


    }


      const checkCofirm1 = event => {
        console.log("event.target.value", event)
        if (event === "NO") {
            setMSchool("YES")
        } else {
            setMSchool("NO")
        }
      };



      const [newDate, setDates] = useState(false)

      const onChanges = (value, dateString) => {
        setDates(dateString)
        console.log('Selected Time: ', value);
        setStartDate(dateString[0])
        setEndDate(dateString[1])

        console.log('Formatted Selected Time: ', dateString);
      };
      const onOk = (value) => {
        console.log('onOk: ', value);
      };

  
      const maxAtte =(e)=>{
        setMNatte(e)
        if(e === "0"){
            alert("Minimum add 1 attendee ")
        }
      }







      const [disabled,setDisabled] = useState(false)

      const  changeHandler=(event)=>{
  
          setFileSelect(event.name)
          setDisabled(true)
  
          let token = "Bearer "+localStorage.getItem('token');
  
          const data = new FormData();
  
          data.append('file', event)
  
          const instance = axios.create({
              baseURL: api+ 'workshopImage/upload',
              timeout: 1000000,
              headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
          });
  
  
          instance.post('', data).then((response) =>{
  
              console.log("respooonse", response.data)
              setImage(response.data.Location)
              setDisabled(false)

          }).catch((error) =>{     
              console.log('error',error.message)  
          });
  
      }
  



    return(
        <Fragment>

    {!result?

        <div className="container">
                <div className="loader_container"><FullPageLoader /></div>
        </div>

    :

        <Fragment>

            {step ===3?null:
            <Steps current={step}>
                <Steps.Item title="General Event Information" description="" />
                <Steps.Item title="Participant Information" description="" />
                <Steps.Item title="Registration Form Configuration" description="" />
            </Steps>
            }

        <hr />   




        {step === 0?
            <Panel header={`General Event Information`}>
                <form className="needs-validation" noValidate>
                    <div className="form-wrpr">

                        <div className="cards formcard medium">
                            <div className="cards-body" >

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-12" >
                                            <label style={{fontSize:'14px', color:'black', }} className="degreehead">Event Title <span style={{color: "red"}}>*</span></label>
                                            <Input style={{fontSize:'14px', color:'black', }}value={title} onChange={setTitle} placeholder="Enter Title" />
                                            </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label className="degreehead">Description</label>
                                            <RteEventComponent setdescription={setDescription} description={description} />     
                                        </div>
                                    </div>
                                </div>


                              


                                {/* <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-12">
										    <label style={{fontSize:'14px', color:'black', }} >Date:<span style={{color: "red"}}>*</span></label><br />
                                        {startDate && endDate ?
                                            <Space direction="vertical" size={12}>
                                                <RangePicker
                                                showTime={{
                                                    format: 'hh:mm a',
                                                }}
                                                format="MM-DD-YYYY hh:mm a"
                                                defaultValue={startDate && endDate ?[
                                                    moment(startDate, "MM-DD-YYYY hh:mm a"),
                                                    moment(endDate, "MM-DD-YYYY hh:mm a")
                                                ]:null}
                                                onChange={onChanges}
                                                onOk={onOk}
                                                />
                                            </Space>:null}
                                            {startDateErr === true && endDateErr === true?<span style={{color:'red', fontSize:12}}>Date is Required.</span>:null}

                                        </div>							
                                    </div>
                                </div> */}

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >Date:<span style={{color: "red"}}>*</span></label><br />
                                            {startDate &&
                                            <DatePicker
                                                showTime={{ format: 'hh:mm a' }}
                                                format="MM-DD-YYYY hh:mm a"
                                                
                                                defaultValue={moment( moment(startDate).format('MM-DD-YYYY HH:mm a'), "MM-DD-YYYY hh:mm a")} 
                                                style={{width:"100%", height:"45px", borderRadius:"5px"}}  
                                                onChange={(e)=>{setStartDate(e)}} 
                                                />
                                            }

                                            {startDateErr === true ? <span style={{color:'red', fontSize:12}}>End Date is Required.</span>:null}
                                        </div>		
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >Date:<span style={{color: "red"}}>*</span></label><br />
                                            {endDate &&
                                            <DatePicker
                                                showTime={{ format: 'HH:mm a' }}
                                                format="MM-DD-YYYY hh:mm a"
                                                defaultValue={moment( moment(endDate).format('MM-DD-YYYY HH:mm a'), "MM-DD-YYYY hh:mm a")} 
                                                style={{width:"100%", height:"45px", borderRadius:"5px"}}  
                                                onChange={(e)=>{setEndDate(e)}}
                                                // diplay on 12 hours format
                                                />
                                            }

                                            {endDateErr === true?<span style={{color:'red', fontSize:12}}>End Date is Required.</span>:null}
                                        </div>							
                                    </div>
                                </div>



                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >Location:<span style={{color: "red"}}>*</span></label>
                                            <Input style={{fontSize:'14px', color:'black', }}value={location} onChange={setLocation} placeholder="Enter Location" />                                        
                                        </div>
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >Address:</label>
                                            <Input style={{fontSize:'14px', color:'black', }}value={address} onChange={setAddress} placeholder="Enter Address" />                                        
                                        </div>								
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >City:<span style={{color: "red"}}>*</span></label>
                                            <Input style={{fontSize:'14px', color:'black', }}value={city} onChange={setCity} placeholder="Enter City" />                                        
                                        </div>
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >State :<span style={{color: "red"}}>*    </span></label><br/>
                                            <Dropdown title={states?states:"Select State"}
                                             style={{ width:'100%', height:'10px'}}  >
                                                {statess.map((item, index)=> (

                                                    <Fragment key={index}>
                                                    <Dropdown.Item value={item}
                                                        defaultChecked={states}
                                                        onClick={() => {{setStates(item);
                                                            // console.log("aaaa")
                                                            }}}

                                                        >{item}</Dropdown.Item>
                                                    </Fragment>
                                                ))}
                                            </Dropdown>
                                 
                                        </div>								
                                    </div>
                                </div>


                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >Zipcode:</label>
                                            <Input style={{fontSize:'14px', color:'black', }}value={zip} onChange={setZip} placeholder="Enter Zipcode" />                                        
                                        </div>
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >Detail Page URL:</label>
                                            <Input style={{fontSize:'14px', color:'black', }}value={pageURL} onChange={setPageURL} placeholder="Enter Detail Page URL" />                        

                                        </div>								
                                    </div>
                                </div>



                                <div className="form-group">
								<div className="row">
									<div className="col-md-12">	
										<label >Upload image</label>	
										<div>
											<div class='file-input file-conferecne' style={{background:"#e6e8eaab", width:'100%'}}>
											<input type='file' onChange={(event)=>{changeHandler(event.target.files[0]);}} />	
                                                {image?
                                                    <img src={image} width="5%" />:
                                                    <span span class='button' style={{background:'dodgerblue', color:'#fff', fontWeight:'500', fontSize:'12px'}}>Choose</span>
                                                }
											<span class='labels' style={{color:image?'dodgerblue':'gray', fontWeight:'500', fontSize:'12px', paddingLeft:image?'10px':null }} data-js-label>{!image?"No file selected":fileSelect}</span>
											</div>
										</div>
									</div>
								</div>
							</div>




                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-12" >
                                            {/* <Checkbox value={preg === "NO"?"NO":"YES"} checked={preg === "NO"?false:true} onChange={checkCofirm}>Event is open for participant registration (Participants can only register when this is checked.)</Checkbox> */}
                                            <Checkbox style={{color:'#000'}} value={mschool === "NO"?"NO":"YES"} checked={mschool === "NO"?false:true} onChange={checkCofirm1}><p style={{fontSize:'16px', fontWeight:'500'}}>Event is open to member schools only (Only participants from GISA member schools can register when this is checked.)</p></Checkbox>
                                        </div>
                                    </div>
                                </div>





                                <h6 style={{color: "red"}}>* Required Fields</h6>
                                

                            </div>
                        </div>
                        
                    </div>
                </form>
            </Panel>:null
        }

        {step ===1?
            <Panel header={`Participant Information`}>
                <form className="needs-validation" noValidate>
                    <div className="form-wrpr">
                        <div className="cards formcard medium">
                            <div className="cards-body" >
                                


                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6" >
                                            <label style={{fontSize:'14px', color:'black', }} >Participant price :</label>
                                            <InputGroup inside >
                                                <InputGroup.Addon>$</InputGroup.Addon>
                                                    <Input style={{fontSize:'14px', color:'black', }}value={pPrice} onChange={setPPrice} />
                                                <InputGroup.Addon>.00</InputGroup.Addon>
                                            </InputGroup>      
                                            <label style={{fontSize:'14px', color:'black', }} >(for members)</label>                               
                                        </div>
                                        <div className="col-md-6" >
                                        <label style={{fontSize:'14px', color:'black', }} >Non member participant price :</label>
                                            <InputGroup inside >
                                                <InputGroup.Addon>$</InputGroup.Addon>
                                                    <Input disabled={mschool ==="YES"?true:false} style={{fontSize:'14px', color:'black', }}value={nmPrice} onChange={setNMprice}  />
                                                <InputGroup.Addon>.00</InputGroup.Addon>
                                            </InputGroup>     
                                            <label style={{fontSize:'14px', color:'black', }} >(Leave blank or enter 0 if same as member price or if nonmember participants are not allowed.)  </label>                                     
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6" >
                                            <label style={{fontSize:'14px', color:'black', }} >Registration deadline :</label>
                                                <DatePickers
                                                    onChange={(date) => {
                                                    // const d = new Date(date).toLocaleDateString('fr-FR');
                                                    setRdead(date);
                                                    // console.log(date)
                                                    }}
                                                    style={{width:'200%'}}
                                                    // defaultValue={rdead?null:null}
                                                    className="form-controls" size="lg"  placeholder={rdead?moment(rdead).format("YYYY-MM-DD"):"Deadline Date (YYYY-MM-DD)"} />                        
                                        </div>
                                        <div className="col-md-6" >
                                        <label style={{fontSize:'14px', color:'black', }} >Additional Price for Late registration :</label>
                                            <InputGroup inside >
                                                <InputGroup.Addon>$</InputGroup.Addon>
                                                    <Input style={{fontSize:'14px', color:'black', }}value={lrPrice} onChange={setLRprice} />
                                                <InputGroup.Addon>.00</InputGroup.Addon>
                                            </InputGroup>     
                                            <label style={{fontSize:'14px', color:'black', }} >Enter total price for event if registering after deadline. Enter zero if late registration will NOT be allowed.</label>                                     
                                        </div>
                                    </div>
                                </div>

                                <h6 style={{color: "red"}}>* Required Fields</h6>



                            </div>
                        </div>
                    </div>
                </form>
           </Panel>:null
        }

        {step === 2?
            <Panel header={`Registration Form Configuration`}>
                <form className="needs-validation" noValidate>
                    <div className="form-wrpr">
                        <div className="cards formcard medium" >
                            <div className="cards-body">
                                <div className="form-group">
                                    <div className="row" style={{paddingTop:'20px'}}>
                                        <div className="col-md-4">
                                            <label style={{fontSize:'14px', color:'black', fontWeight:500}} >Registrants firstname field</label><br />
                                        </div>
                                        <div className="col-md-8" >
                                            <Radio.Group defaultValue="REQUIRED" orientation="horizontal" onChange={(value)=>{setRegFir(value)}}>
                                            <Radio size="xl" value="REQUIRED" color="primary" labelColor="primary">
                                                REQUIRED
                                            </Radio>
                                            <Radio size="xl" value="OPTIONAL" isDisabled color="secondary" labelColor="secondary">
                                                OPTIONAL
                                            </Radio>
                                            <Radio size="xl" value="NOTSHOW" isDisabled  color="error" labelColor="error">
                                                Not Show
                                            </Radio>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="row" style={{paddingTop:'20px'}}>
                                        <div className="col-md-4">
                                            <label style={{fontSize:'14px', color:'black', fontWeight:500}} >Registrants lastname field</label><br />
                                        </div>
                                        <div className="col-md-8" >
                                            <Radio.Group defaultValue="REQUIRED" orientation="horizontal" onChange={(value)=>{setRegLas(value)}}>
                                            <Radio size="xl" value="REQUIRED" color="primary" labelColor="primary">
                                                REQUIRED
                                            </Radio>
                                            <Radio size="xl" value="OPTIONAL" isDisabled  color="secondary" labelColor="secondary">
                                                OPTIONAL
                                            </Radio>
                                            <Radio size="xl" value="NOTSHOW"  isDisabled color="error" labelColor="error">
                                                Not Show
                                            </Radio>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="row" style={{paddingTop:'20px'}}>
                                        <div className="col-md-4">
                                            <label style={{fontSize:'14px', color:'black', fontWeight:500}} >Registrants phone field</label><br />
                                        </div>
                                        <div className="col-md-8" >
                                            <Radio.Group defaultValue="REQUIRED" orientation="horizontal" onChange={(value)=>{setRegEmail(value)}}>
                                            <Radio size="xl" value="REQUIRED" color="primary" labelColor="primary">
                                                REQUIRED
                                            </Radio>
                                            <Radio size="xl" value="OPTIONAL" isDisabled  color="secondary" labelColor="secondary">
                                                OPTIONAL
                                            </Radio>
                                            <Radio size="xl" value="NOTSHOW" isDisabled  color="error" labelColor="error">
                                                Not Show
                                            </Radio>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="row" style={{paddingTop:'20px'}}>
                                        <div className="col-md-4">
                                            <label style={{fontSize:'14px', color:'black', fontWeight:500}} >Registrants email field</label><br />
                                        </div>
                                        <div className="col-md-8" >
                                            <Radio.Group defaultValue="REQUIRED" orientation="horizontal" onChange={(value)=>{setRegPhone(value)}}>
                                            <Radio size="xl" value="REQUIRED" color="primary" labelColor="primary">
                                                REQUIRED
                                            </Radio>
                                            <Radio size="xl" value="OPTIONAL" isDisabled  color="secondary" labelColor="secondary">
                                                OPTIONAL
                                            </Radio>
                                            <Radio size="xl" value="NOTSHOW" isDisabled  color="error" labelColor="error">
                                                Not Show
                                            </Radio>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="row" style={{paddingTop:'20px'}}>
                                        <div className="col-md-4">
                                            <label style={{fontSize:'14px', color:'black', fontWeight:500}} >Registrants title at school field</label><br />
                                        </div>
                                        <div className="col-md-8" >
                                            <Radio.Group defaultValue={regTit} orientation="horizontal" onChange={(value)=>{setRegTit(value)}}>
                                            <Radio size="xl" value="REQUIRED" color="primary" labelColor="primary">
                                                REQUIRED
                                            </Radio>
                                            <Radio size="xl" value="OPTIONAL"  color="secondary" labelColor="secondary">
                                                OPTIONAL
                                            </Radio>
                                            <Radio size="xl" value="NOTSHOW"  color="error" labelColor="error">
                                                Not Show
                                            </Radio>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </Panel>
            :
            null
        }

        <hr />






        {step !== 4?
            <div> 
                <ButtonGroup style={{width:'100%', marginTop:'2%'}}>
                        <Button  className="button-focus create-conference-btn prev-conference-btn" style={{background:'#fff', color:'#3498ff'}}  onClick={onPrevious} disabled={step === 0}>
                            Previous
                        </Button>
                    {step === 2?
                        <Button appearance="primary" className="button-focus create-conference-btn" onClick={EventSubmit} disabled={step === 1}>
                            Update Conference Manager
                        </Button>:
                        <Button appearance="primary" className="button-focus create-conference-btn" onClick={onNext} disabled={disabled}>
                            Next
                        </Button>
                    }
                </ButtonGroup>
            </div>:null
        }

    </Fragment>}
           
        </Fragment>
    )
}

export default WorkshopUpdate;